module.exports = __webpack_public_path__ + "static/img/discount.3b92e52.png";